import { MonitoringTenantUser } from '@hakimo-ui/hakimo/types';
import { Checkbox } from '@hakimo-ui/shared/ui-base';
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

export function getEffectiveAccess(
  user: MonitoringTenantUser,
  pending: Record<string, boolean>
): boolean {
  return user.id in pending ? pending[user.id] : user.hasAccess;
}

interface Props {
  tenantId: string;
  tenantName: string;
  users: MonitoringTenantUser[];
  withAccessCount: number;
  totalUsers: number;
  collapsed: boolean;
  isUpdating: boolean;
  pending: Record<string, boolean>;
  onToggleCollapsed: (tenantId: string) => void;
  onToggleUser: (userId: string, hasAccess: boolean, checked: boolean) => void;
}

export function MonitoringUserGroup({
  tenantId,
  tenantName,
  users,
  withAccessCount,
  totalUsers,
  collapsed,
  isUpdating,
  pending,
  onToggleCollapsed,
  onToggleUser,
}: Props) {
  return (
    <div>
      <button
        type="button"
        onClick={() => onToggleCollapsed(tenantId)}
        className="text-onlight-text-1 dark:text-ondark-text-1 hover:bg-onlight-bg-2 dark:hover:bg-ondark-bg-2 mb-1 flex w-full items-center justify-between rounded px-1 py-1 text-left text-sm font-semibold"
      >
        <span className="flex items-center gap-1">
          {collapsed ? (
            <ChevronRightIcon className="h-4 w-4" />
          ) : (
            <ChevronDownIcon className="h-4 w-4" />
          )}
          {tenantName}
        </span>
        <span className="text-onlight-text-2 dark:text-ondark-text-2 text-xs font-normal">
          {withAccessCount}/{totalUsers} have access
        </span>
      </button>
      {!collapsed && (
        <div className="divide-onlight-line-2 dark:divide-ondark-line-2 divide-y pl-5">
          {users.map((u) => {
            const checked = getEffectiveAccess(u, pending);
            return (
              <div
                key={u.id}
                className="flex items-center justify-between gap-3 py-1.5"
              >
                <div className="flex min-w-0 flex-col">
                  <span className="text-onlight-text-1 dark:text-ondark-text-1 truncate text-sm">
                    {u.name}
                  </span>
                  <span className="text-onlight-text-2 dark:text-ondark-text-2 truncate text-xs">
                    {u.email}
                  </span>
                </div>
                <Checkbox
                  checked={checked}
                  disabled={isUpdating || !u.isEnabled}
                  onChange={(c) => onToggleUser(u.id, u.hasAccess, c)}
                />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default MonitoringUserGroup;
